(function () {
  function norm(str) {
    if (!str) return '';
    return String(str)
      .toLowerCase()
      .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
      .replace(/[^a-z0-9 ]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function initSection(root) {
    if (!root) return;

    var input = root.querySelector('input[id^="FanshopFilterInput-"]');
    var sortSelect = root.querySelector('select[id^="FanshopSortSelect-"]');
    var list = root.querySelector('div[id^="FanshopList-"]');
    var meta = root.querySelector('p[id^="FanshopResultMeta-"]');

    if (!input || !sortSelect || !list) return;

    function getItems() {
      return Array.prototype.slice.call(list.querySelectorAll('.fanshop-item[data-q][data-title]'));
    }

    function setMeta(txt) {
      if (meta) meta.textContent = txt;
    }

    function apply() {
      var items = getItems();
      if (!items.length) {
        setMeta('0 von 0 Fanshops');
        return;
      }

      var q = norm(input.value);
      var mode = sortSelect.value || 'az';
      var visible = [];

      for (var i = 0; i < items.length; i++) {
        var el = items[i];
        var hay = norm(el.getAttribute('data-q') || '');
        var title = norm(el.getAttribute('data-title') || '');
        var show = (!q) || hay.indexOf(q) !== -1 || title.indexOf(q) !== -1;
        el.style.display = show ? '' : 'none';
        if (show) visible.push(el);
      }

      visible.sort(function (a, b) {
        var ta = (a.getAttribute('data-title') || '').toLowerCase();
        var tb = (b.getAttribute('data-title') || '').toLowerCase();
        if (ta < tb) return mode === 'za' ? 1 : -1;
        if (ta > tb) return mode === 'za' ? -1 : 1;
        return 0;
      });

      for (var j = 0; j < visible.length; j++) list.appendChild(visible[j]);

      setMeta(visible.length + ' von ' + items.length + ' Fanshops');
    }

    // Wichtig: bei BFCache/Timing nicht nur 1x initialisieren.
    // Wir "re-initialisieren" safe: Events einmal binden, aber apply jederzeit neu ausführen.
    if (!root.__fanshopBound) {
      root.__fanshopBound = true;

      input.addEventListener('input', function () { apply(); });
      sortSelect.addEventListener('change', function () { apply(); });
    }

    // Robust warten bis Items wirklich im DOM sind
    var tries = 0;
    (function waitForItems() {
      tries++;
      var items = getItems();
      if (items.length) {
        if (!sortSelect.value) sortSelect.value = 'az';
        apply();
        return;
      }
      setMeta('Lade Fanshops …');
      if (tries < 50) setTimeout(waitForItems, 120);
      else setMeta('0 von 0 Fanshops');
    })();
  }

  function initAll() {
    var sections = document.querySelectorAll('[data-section="fanshop-search-grid"]');
    for (var i = 0; i < sections.length; i++) {
      initSection(sections[i]);
    }
  }

  // 1) normal
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // 2) Safari BFCache: wird ausgelöst, wenn Seite aus Cache wiederhergestellt wird
  window.addEventListener('pageshow', function () {
    initAll();
  });

  // 3) Shopify Editor Events (schadet live nicht)
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:reorder', initAll);
})();
